import React, { useState, useEffect } from 'react';
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle
} from 'reactstrap';
import { MdOutlineContactPhone } from 'react-icons/md';
import { useClickToCallOnPhoneField } from 'views/CRM/shared/hooks/useClickToCallOnPhoneField';
import TemplatesModal from 'views/ServicePanel/components/QueueContent/components/Contact/TemplatesModal';
import SendEmailModal from '../SendEmailModal';
import { getContactsAttempts } from '../../../../shared/ContactAttempt/utils';
import contactService from 'views/CRM/Contact/services/contactService';
import { toast } from 'react-toastify';

const LeadActionsModal = ({ leadData }) => {
  const { canMakeCall, makeCall, canSendMessage } =
    useClickToCallOnPhoneField();
  const [dropdown, setDropdown] = useState(false);
  const [whatsAppMessageContactInfoLead, setWhatsAppMessageContactInfoLead] =
    useState({});
  const [isModalTemplateMessageLeadOpen, setIsModalTemplateMessageLeadOpen] =
    useState(false);
  const [callUniqueId, setCallUniqueId] = useState(null);
  const [chatCreatedOnIsolatedMessageId, setChatCreatedOnIsolatedMessageId] =
    useState(null);
  const [isModalEmailLeadOpen, setIsModalEmailLeadOpen] = useState(false);
  const [leadEmail, setLeadEmail] = useState(null);

  const toggle = () => setDropdown(!dropdown);

  function handleWhatsAppMessage(phone, ddi) {
    if (!phone) return;
    contactService
      .getContactByTelephoneAndDdi(phone, ddi)
      .then(({ data }) => {
        if (data.data.phone === phone && data.data.ddi === ddi) {
          let dataDTO = {
            nome: leadData.name,
            telefone: data.data?.phone,
            ddi: data.data?.ddi
          };

          setWhatsAppMessageContactInfoLead(dataDTO);
          setIsModalTemplateMessageLeadOpen(!isModalTemplateMessageLeadOpen);
          return whatsAppMessageContactInfoLead;
        }
        toast.warn('Lead não tem um contato salvo.', {
          autoClose: 3000,
          closeOnClick: true
        });
        return;
      })
      .catch(() => {
        toast.warn('Lead não tem um contato salvo.', {
          autoClose: 3000,
          closeOnClick: true
        });
        return;
      });
  }

  function handleEmailMessage(email) {
    if (!email) return;

    setLeadEmail(email);
    setIsModalEmailLeadOpen(!isModalEmailLeadOpen);
  }

  useEffect(() => {
    if (chatCreatedOnIsolatedMessageId) {
      getContactsAttempts(
        chatCreatedOnIsolatedMessageId,
        'CHAT',
        'LEAD',
        leadData.id
      );
      return;
    }

    if (callUniqueId) {
      getContactsAttempts(callUniqueId, 'TELEFONIA', 'LEAD', leadData.id);
      return;
    }
  }, [callUniqueId, chatCreatedOnIsolatedMessageId, leadData.id]);

  return (
    <>
      <Button color="success" onClick={toggle} size="sm">
        <MdOutlineContactPhone size={17} />
      </Button>
      <Dropdown
        isOpen={dropdown}
        toggle={toggle}
        style={{ top: '-110px', left: '0' }}
      >
        <DropdownToggle
          color="link"
          style={{
            margin: '0',
            padding: '0'
          }}
        ></DropdownToggle>
        <DropdownMenu style={{ maxHeight: '7rem' }} positionFixed>
          <DropdownItem
            value="Enviar mensagem whatsapp"
            onClick={() => handleWhatsAppMessage(leadData.phone, leadData.ddi)}
            disabled={!canSendMessage(leadData.phone)}
            style={{ padding: '0.3rem 1rem' }}
          >
            <i className="fas fa-comment" />
            Enviar mensagem whatsapp
          </DropdownItem>
          <DropdownItem
            value="Realizar chamada"
            onClick={() => makeCall(leadData.phone, setCallUniqueId, true)}
            disabled={!canMakeCall(leadData.phone)}
            style={{ padding: '0.3rem 1rem' }}
          >
            <i className="fas fa-phone" />
            Realizar chamada
          </DropdownItem>
          <DropdownItem
            value="Enviar email"
            onClick={() => handleEmailMessage(leadData.email)}
            disabled={!leadData.email || leadData.email.lenght === 0}
            style={{ padding: '0.3rem 1rem' }}
          >
            <i className="fas fa-envelope" />
            Enviar email
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <TemplatesModal
        isModalOpen={isModalTemplateMessageLeadOpen}
        onModalToggle={setIsModalTemplateMessageLeadOpen}
        clientNumber={whatsAppMessageContactInfoLead.telefone}
        clientDDI={whatsAppMessageContactInfoLead.ddi}
        clientName={whatsAppMessageContactInfoLead.nome}
        clientId={whatsAppMessageContactInfoLead.clientId ?? ''}
        setChatCreatedOnIsolatedMessageId={setChatCreatedOnIsolatedMessageId}
        isTryingToCreateAContactAttempt={true}
        isIsolated={true}
        shouldGetData={dropdown}
      />

      <SendEmailModal
        leadEmail={leadEmail}
        leadId={leadData.id}
        isModalOpen={isModalEmailLeadOpen}
        onModalToggle={setIsModalEmailLeadOpen}
        setIsModalOpen={setIsModalEmailLeadOpen}
      />
    </>
  );
};

export default LeadActionsModal;
